import { render, staticRenderFns } from "./Datepickers.vue?vue&type=template&id=1f2dd388&"
import script from "./Datepickers.vue?vue&type=script&lang=js&"
export * from "./Datepickers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports